import axios from "axios";
import { BaseApiUrl } from "./base";
import { normalizeDeptId, treeNodeDeptId } from '../utils/deptCascaderProps';

const base = BaseApiUrl;
const api = `${base}/api/HeadTeacherWorkAttendance`;

/** 获取或初始化学校方案 */
export const getHeadTeacherWorkAttendancePlan = (schId) => {
  return axios.get(`${api}/GetOrCreatePlan`, { params: { schId } });
};

/** 保存方案 */
export const saveHeadTeacherWorkAttendancePlan = (data) => {
  return axios.post(`${api}/SavePlan`, data);
};

/** 项目列表 */
export const getHeadTeacherWorkAttendanceItems = (schId, page = 1, pageSize = 10) => {
  return axios.get(`${api}/GetItems`, { params: { schId, page, pageSize } });
};

/** 项目下拉选项（返回数组，兼容分页/非分页响应） */
export const getHeadTeacherWorkAttendanceItemOptions = async (schId) => {
  const res = await axios.get(`${api}/GetItems`, { params: { schId, page: 1, pageSize: 100 } });
  if (!(res.data && res.data.success)) return [];
  const data = res.data.response || [];
  return Array.isArray(data) ? data : (data.data || []);
};

/** 配置总览：项目 + 时段汇总 */
export const getHeadTeacherWorkAttendanceConfigOverview = (schId) => {
  return axios.get(`${api}/GetConfigOverview`, { params: { schId } });
};

/** 保存项目 */
export const saveHeadTeacherWorkAttendanceItem = (data) => {
  return axios.post(`${api}/SaveItem`, data);
};

/** 停用项目 */
export const disableHeadTeacherWorkAttendanceItem = (schId, itemId) => {
  return axios.post(`${api}/DisableItem`, null, { params: { schId, itemId } });
};

/** 时段列表 */
export const getHeadTeacherWorkAttendanceSchedules = (schId, itemId, page = 1, pageSize = 10) => {
  return axios.get(`${api}/GetSchedules`, { params: { schId, itemId, page, pageSize } });
};

/** 保存时段 */
export const saveHeadTeacherWorkAttendanceSchedule = (data) => {
  return axios.post(`${api}/SaveSchedule`, data);
};

/** 停用时段 */
export const disableHeadTeacherWorkAttendanceSchedule = (schId, scheduleId) => {
  return axios.post(`${api}/DisableSchedule`, null, { params: { schId, scheduleId } });
};

/** 下载时段导入模板 */
export const downloadHeadTeacherWorkAttendanceScheduleTemplate = () => {
  return axios.get(`${api}/DownloadScheduleImportTemplate`, { responseType: "blob" });
};

/** 导出时段配置 */
export const exportHeadTeacherWorkAttendanceSchedules = (schId, itemId) => {
  return axios.get(`${api}/ExportSchedules`, {
    params: { schId, itemId: itemId || undefined },
    responseType: "blob"
  });
};

/** 解析 Excel 预览（不落库） */
export const previewHeadTeacherWorkAttendanceScheduleImport = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${api}/PreviewScheduleImport`, form, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};

/** 按预览行确认导入 */
export const importHeadTeacherWorkAttendanceSchedulesByRows = (schId, rows) => {
  return axios.post(`${api}/ImportSchedulesByRows`, {
    SchId: schId,
    Rows: rows
  });
};

/** 批量导入时段（文件直导，兼容旧入口） */
export const importHeadTeacherWorkAttendanceSchedules = (schId, file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${api}/ImportSchedules`, form, {
    params: { schId },
    headers: { "Content-Type": "multipart/form-data" }
  });
};

/** 周汇总分页 */
export const getHeadTeacherWorkAttendanceSummaryPage = (params) => {
  return axios.get(`${api}/GetSummaryPage`, { params });
};

/** 导出周汇总 */
export const exportHeadTeacherWorkAttendanceSummary = (params) => {
  return axios.get(`${api}/ExportSummary`, { params, responseType: "blob" });
};

/** 获取个人签到项目参与人员 */
export const getHeadTeacherWorkAttendanceItemStaff = (schId, itemId) => {
  return axios.get(`${api}/GetItemStaff`, { params: { schId, itemId } });
};

/** 保存个人签到项目参与人员 */
export const saveHeadTeacherWorkAttendanceItemStaff = (data) => {
  return axios.post(`${api}/SaveItemStaff`, data);
};

/** 获取项目参与人员预览 */
export const getHeadTeacherWorkAttendanceParticipantPreview = (schId, itemId) => {
  return axios.get(`${api}/GetItemParticipantPreview`, { params: { schId, itemId } });
};

/** 按日统计汇总 */
export const getHeadTeacherWorkAttendanceDailySummary = (params) => {
  return axios.get(`${api}/GetDailyStatSummary`, { params });
};

/** 按日统计明细 */
export const getHeadTeacherWorkAttendanceDailyDetails = (params) => {
  return axios.get(`${api}/GetDailyStatDetails`, { params });
};

/** 导出按日统计 */
export const exportHeadTeacherWorkAttendanceDaily = (params) => {
  return axios.get(`${api}/ExportDailyStat`, { params, responseType: "blob" });
};

/** 停办/恢复场次 */
export const setHeadTeacherWorkAttendanceOccurrenceStatus = (data) => {
  return axios.post(`${api}/SetOccurrenceStatus`, data);
};

/** 设置/取消免签 */
export const setHeadTeacherWorkAttendanceParticipantExempt = (data) => {
  return axios.post(`${api}/SetParticipantExempt`, data);
};

/** 统计管理员列表 */
export const getHeadTeacherWorkAttendanceAdmins = (schId, page = 1, pageSize = 10) => {
  return axios.get(`${base}/api/HeadTeacherWorkAttendanceAdmin/GetList`, { params: { schId, page, pageSize } });
};

/** 保存统计管理员 */
export const saveHeadTeacherWorkAttendanceAdmin = (data) => {
  return axios.post(`${base}/api/HeadTeacherWorkAttendanceAdmin/Save`, data);
};

/** 删除统计管理员 */
export const deleteHeadTeacherWorkAttendanceAdmin = (schId, id) => {
  return axios.post(`${base}/api/HeadTeacherWorkAttendanceAdmin/Delete`, null, { params: { schId, id } });
};

/** 明细分页 */
export const getHeadTeacherWorkAttendanceRecordPage = (params) => {
  return axios.get(`${api}/GetRecordPage`, { params });
};

/** 记录详情 */
export const getHeadTeacherWorkAttendanceRecordDetail = (schId, recordId) => {
  return axios.get(`${api}/GetRecordDetail`, { params: { schId, recordId } });
};

/** 导出明细 */
export const exportHeadTeacherWorkAttendanceRecords = (params) => {
  return axios.get(`${api}/ExportRecords`, { params, responseType: "blob" });
};

/** 下载 blob */
export function downloadHeadTeacherWorkAttendanceBlob(res, defaultName) {
  const blob = new Blob([res.data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  let fileName = defaultName;
  const disposition = res.headers && (res.headers["content-disposition"] || res.headers["Content-Disposition"]);
  if (disposition) {
    const match = disposition.match(/filename\*?=(?:UTF-8'')?([^;]+)/i);
    if (match && match[1]) {
      fileName = decodeURIComponent(match[1].replace(/"/g, "").trim());
    }
  }
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

/** 从部门树节点解析学校 Id。最后修改：2026-10-18 */
export function resolveHeadTeacherWorkAttendanceSchoolIdFromTreeNode(node, fallbackId) {
  const isSchoolType = (type) => {
    const t = String(type || "").toLowerCase();
    return t === "school" || t === "affiliateschool";
  };
  if (node && node.data) {
    const selfType = node.data.DeptOrgType != null ? node.data.DeptOrgType : node.data.deptOrgType;
    if (isSchoolType(selfType)) {
      return treeNodeDeptId(node.data);
    }
  }
  let n = node && node.parent;
  while (n && n.data) {
    const t = n.data.DeptOrgType != null ? n.data.DeptOrgType : n.data.deptOrgType;
    if (isSchoolType(t)) {
      return treeNodeDeptId(n.data);
    }
    n = n.parent;
  }
  return normalizeDeptId(fallbackId);
}

/** 当前页学校 Id。最后修改：2026-10-18 */
export function getHeadTeacherWorkAttendanceCurrentSchoolId(vm) {
  return normalizeDeptId(vm.schoolId) || normalizeDeptId(vm.DepartmentId);
}

export function clearHeadTeacherWorkAttendanceList(vm) {
  if (Object.prototype.hasOwnProperty.call(vm, "rows")) vm.rows = [];
  if (Object.prototype.hasOwnProperty.call(vm, "users")) vm.users = [];
  if (Object.prototype.hasOwnProperty.call(vm, "items")) vm.items = [];
  if (Object.prototype.hasOwnProperty.call(vm, "schedules")) vm.schedules = [];
  if (Object.prototype.hasOwnProperty.call(vm, "total")) vm.total = 0;
  if (Object.prototype.hasOwnProperty.call(vm, "page")) vm.page = 1;
}

/** 切换学校/范围节点。最后修改：2026-10-18 */
export function onHeadTeacherWorkAttendanceSchoolChange(vm, schoolId, scopeDepartmentId) {
  const sch = normalizeDeptId(schoolId);
  const scopeId = normalizeDeptId(scopeDepartmentId) || sch;
  vm.schoolId = sch || '';
  vm.DepartmentId = scopeId || '';
  if (Object.prototype.hasOwnProperty.call(vm, "scopeDepartmentId")) {
    vm.scopeDepartmentId = scopeId || '';
  }
  clearHeadTeacherWorkAttendanceList(vm);
}
